<template>
  <div>


    <!-- barsha -->
    <div class="custom-loader-wrapper for-employee-page" v-if="payslip_loader">
        <div class="text-center">
            <span class="d-block max-450">{{payslip_loader_text}}</span>
            <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
        </div>
    </div>
        <form @submit="formSubmit" enctype="multipart/form-data">
        <input class="input" type="hidden" v-model="fdata.id" >
        <input class="input" type="hidden" v-model="employee_id" >
        <input class="input" type="hidden" v-model="fiscal_year" >
        <input class="input" type="hidden" v-model="from_date" >
        <input class="input" type="hidden" v-model="to_date" >
        <input class="input" type="hidden" v-model="pay_slip_ref" >
        <input class="input" type="hidden" v-model="pay_slip_name" >
        <div class="row ">

          <div class="col-md-12 action-button">
            <!-- <b-overlay :show="action_loader" rounded="sm"> -->
              <!-- <b-button class="border rounded bg-light float-right py-1 px-2 mt-4 ml-2" type="submit" variant="primary" @click="downloadPaySlip(payslip,fiscal_year,'','true')"><i class="fas fa-print px-1" aria-hidden="true" style="font-size:16px;"></i> Print</b-button> -->
              <b-button class="border rounded bg-light float-right py-1 px-2 ml-2 btn-primary custom-wizard-btn custom-wizard2-btn" type="submit" variant="primary" @click="emailTaxCards(taxcard)"><i class="far fa-envelope px-1" aria-hidden="true" style="font-size:16px;"></i> Email</b-button>
              <b-button class="border rounded bg-light float-right py-1 px-2 ml-2 " type="submit" variant="primary" @click="downloadTaxCards(taxcard,fiscal_year)">Download PDF</b-button>


            <!-- </b-overlay> -->
            </div>
        </div>
        <div class="row payslip-details-card">
          <div class="col-md-12 text-center pay-slip-title">
          <p  class="first">{{company_name}}</p>
          <p class="second"> {{card_title}}</p>
          <p class="third"> Income Year {{fiscal_year}}</p>
          </div>
        </div>

        <div class="row payslip-details-card">

          <div class="col-md-12 payslip-details-info">

            <!-- <div class="row payslip-details-info-inner">
              <template v-for="(row, index) in dynamic_fields">
                <div class="col-md-6 payslip-details-info-right">
                  <div class="wrapper">
                  <div class='first' :key="index" >{{row.header_left_name}}</div>
                  <div class='second'>
                    <template  v-if="row.header_left_name !='Month'">{{row.header_left_value}}</template>
                    <template v-else>{{pmonth+' '+pyear}}</template>
                  </div>
                  </div>
                </div>

                <div class="col-md-6 payslip-details-info-right">
                  <div class="wrapper">
                  <div class='first'>{{row.header_right_name}}</div>
                  <div class='second'>
                    <template  v-if="row.header_right_name != 'Month'">{{row.header_right_value}}</template>
                    <template v-else>{{pmonth+' '+pyear}}</template>
                  </div>
                  </div>
                </div>
              </template>
            </div> -->
          </div>
        </div>


        <div class="row payslip-details-card">
          <div class="col-md-12">
            <div class="payslip-details-title">Income Details</div>
            <table class="table">
              <thead>
                <tr class="table-head table-head-center" style="font-weight: bold; text-align: left;">
                  <td>Heads of Income</td>
                  <td>{{fdata.month}} {{fdata.year}}</td>
                  <td>YTD (up to previous month)</td>
                  <td>Projected Annual</td>
                </tr>

              </thead>
               <tbody class="slip-details-table">
                    <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1'">
                      <template v-if="salaryhead.field_key != 'basic_salary_before_pregross' && salaryhead.field_key != 'house_rent_before_pregross' && salaryhead.field_key != 'conveyance_allowance_before_pregross' && salaryhead.field_key != 'medical_allowance_before_pregross'">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                      {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>
                    </template>

                    </tr>


                    <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'custom_gross_salary_components' && !(salaryhead.taxable=='0' && salaryhead.value=='0')">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                      {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>


                   <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.1' && !(salaryhead.taxable=='0' && salaryhead.value=='0')">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                      {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>


                    <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2' && !(salaryhead.taxable=='0' && salaryhead.value=='0')">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                      {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>






                   <!-- Off cycle starts --->
                   <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Basic Salary'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                       {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>


                   <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear House Rent Allowance'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
                      <td>Arrear House Rent Allowance</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                       {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>

                    <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Conveyance Allowance'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
                      <td>Arrear Conveyance Allowance</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                       {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>

                   <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Medical Allowance'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
                      <td>Arrear Medical Allowance</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                       {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>

                    <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'custom_gross_salary_components_arrear' && !(salaryhead.taxable=='0' && salaryhead.value=='0') && salaryhead.taxable!='0.00' && salaryhead.value!='0.00'">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                      {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>



                   <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear PF Employer\'s Contribution'  && !(salaryhead.value=='0' && salaryhead.taxable=='0')">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                       {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>



                   <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'off_cycle_adhocs'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                       {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>

                    </tr>


                    <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
                      <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                      {{salaryhead.ytd}}
                      </td>

                      <td style="text-align: right;">
                      {{salaryhead.annual}}
                      </td>
                    </tr>

              <!--<tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'bonus_and_incentives'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
                      <td>{{salaryhead.head}}</td>
                <td style="text-align: right;">{{salaryhead.value}}</td>
                <td style="text-align: right;">{{salaryhead.ytd}}</td>
                <td style="text-align: right;">{{salaryhead.annual}}</td>
                <td style="text-align: right;">({{salaryhead.exemption}})</td>
                <td style="text-align: right;">{{salaryhead.taxable}}</td>
                    </tr>-->

              <!---------------------- Adding Overtime Bonus Data ---------------------->

              <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'overtime_holiday_manual' || salaryhead.displayset == 'overtime_holiday_incremental_days' || salaryhead.displayset == 'overtime_holiday_fixed' || salaryhead.displayset == 'overtime_holiday_incremental_hours') && !(salaryhead.taxable=='0' && salaryhead.value=='0')">
                        <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                  <td style="text-align: right;">
                    {{salaryhead.ytd}}
                  </td>
                  <td style="text-align: right;">
                    {{salaryhead.annual}}
                  </td>

                    </tr>

              <!---------------------- Adding Contracted Variable Data ---------------------->

              <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'contracted_variable'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
                      <td>{{salaryhead.head}}</td>
                <td style="text-align: right;">{{salaryhead.value}}</td>
                <td style="text-align: right;">
                  {{salaryhead.ytd}}
                </td>

                <td style="text-align: right;">
                {{salaryhead.annual}}
                </td>

                    </tr>

              <!---------------------- Adding Manual Leave Encashment Data ---------------------->

              <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'manual_leave_encashment'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
                      <td>{{salaryhead.head}}</td>
                <td style="text-align: right;">{{salaryhead.value}}</td>
                <td style="text-align: right;">
                  {{salaryhead.ytd}}
                </td>

                <td style="text-align: right;">
                {{salaryhead.annual}}
                </td>

                    </tr>

                    <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_taxable'" class="s-tfoot" style="font-weight: bold;">
                    <td>Total</td><td style="text-align: right;">{{salaryhead.value}}</td>
                    <td style="text-align: right;">
                    {{salaryhead.ytd}}
                    </td>

                    <td style="text-align: right;">
                    {{salaryhead.annual}}
                    </td>

                    </tr>
               </tbody>
              </table>
           </div>
     </div>

     <div class="row payslip-details-card">
          <div class="col-md-12">
            <div class="payslip-details-title">Taxable Income</div>
            <table class="table border">
               <tbody>
                <!-- <td style="background: transparent; border: none !important;"></td>  -->
                  <!-- Abdullah remoevd border-none from below linw  -->
                    <tr class="table-head table-head-center " style="font-weight: bold; background: transparent;"><td>Condition</td><td>Exemption Amount</td><td>Amount</td></tr>
                    <tr>
                        <td colspan="2" style="font-weight: bold; border-right: 1px solod #000;">Lower of:</td>
                        <!-- Abdullah remoevd border-none from below linw  -->
                        <td style="background: transparent !important;"></td>
                    </tr>
                    <tr class="table-row hover-bg">
                        <td>1/3 of projected annual income</td>
                        <td style="text-align: right;">{{exmp_from_projection}}</td>
                        <td rowspan="2" style="text-align: right; vertical-align: middle;">
                            {{exemption_total}}
                        </td>
                    </tr>
                    <tr>
                        <td>Maximum limit</td>
                        <td style="text-align: right;"><template v-if="decimal_setting == 'no'">{{max_exemption_val}}</template><template v-else>{{max_exemption_val}}</template></td> <!--Afrin: changed 7-9-->
                    </tr>
                    <tr v-for="salaryhead in salaryheads"  v-if="salaryhead.displayset == 'total_annual_taxable'" class="s-tfoot" style="">
                        <td colspan="2" style="">Total Taxable Income</td>
                        <td style="text-align: right;">{{salaryhead.value}}</td>
                    </tr>
               </tbody>
              </table>
           </div>
      </div>

     <div class="row payslip-details-card">
          <div class="col-md-12">
            <div class="payslip-details-title">Calculation of Income Tax Liability</div>
            <table class="table">
               <tbody>
                    <tr class="table-head table-head-center" style="font-weight: bold;"><td>Slab</td><td>Taxable Income</td> <td>Tax Rate</td> <td>Tax Amount</td></tr>
                    <tr class="table-row hover-bg" v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.displayset == '3'">
                      <td>{{slabsnvalue.head}}</td><td style="text-align: right;">{{slabsnvalue.slab}}</td><td style="text-align: right;">{{slabsnvalue.tax_rate}}</td><td style="text-align: right;">{{slabsnvalue.tax_amount}}</td>
                    </tr>
                    <tr v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.displayset == '300'" class="s-tfoot" style="font-weight: bold;">
                      <td>{{slabsnvalue.head}}</td><td style="text-align: right;">{{slabsnvalue.slab}}</td><td style="text-align: center;">{{slabsnvalue.tax_rate}}</td><td style="text-align: right;">{{slabsnvalue.tax_amount}}</td>
                    </tr>
               </tbody>
              </table>
           </div>
      </div>

      <div class="row payslip-details-card" v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.head == 'On the balance Tk.' && slabsnvalue.residency!='no'">
          <div class="col-md-12">
            <div class="payslip-details-title">Calculation of Tax Credit on Investment</div>
            <table class="table">
               <tbody>
                    <tr class="table-head table-head-center" style="font-weight: bold;"><td>#</td><td>Details</td><td>Eligible Investment</td><td>Amount</td><td>Credit Amount</td></tr>
              <tr class="table-row hover-bg" style="font-style: italic; font-weight: bold;"><td colspan="5">Lower of:</td></tr>
                    <tr class="table-row hover-bg">
                      <td>a)</td>
                      <td>0.03 x Total Taxable Income</td>
                      <td style="text-align: right;">{{max_inv_limit_new}}</td>
                      <td style="text-align: right;">{{max_inv_rebate_new}}</td>
                      <td class="text-right align-middle" rowspan="3">({{eligible_investment_rebate_new}})</td>
                    </tr>

                    <tr class="table-row hover-bg">
                      <td>b)</td>
                      <td>{{ rebet_slab_global_rate }} x Actual investment declared/made by employee</td> <!-- CHANGE: max_allowed_rebate_limit -->
                      <td style="text-align: right;">{{invested_amount_new}}</td>
                      <td style="text-align: right;">{{investment_rebate_new}}</td>
                   </tr>
               <tr class="table-row hover-bg">
                      <td>c)</td>
                      <td colspan="2">Maximum Allowable Limit <span style="font-style: italic;">(as per prevailing regulations)</span></td>
                      <!-- <td style="text-align: right;"><template v-if="decimal_setting == 'no'">1,000,000</template><template v-else>1,000,000.00</template></td> -->
                      <td style="text-align: right;">{{max_allowed_rebate_limit}}</td> <!-- CHANGE: max_allowed_rebate_limit -->
                   </tr>


               </tbody>
              </table>
           </div>
      </div>

     <div class="row payslip-details-card">
      <div class="col-md-12">
        <div class="payslip-details-title">Income Tax Payable</div>
        <!-- alpha fix- added class border to table to show border in tax card -->
        <table class="table border">
           <tbody>
                  <tr class="table-head table-head-center"><td>Details</td><td class="w-25">&nbsp;</td><td class="text-center">Amount</td></tr>
                  <tr style="font-weight: bold;"><td>Total Income Tax Payable</td><td class="w-25">&nbsp;</td><td style="text-align: right;">{{taxdata['tax_total']}}</td></tr>
                  <tr class="table-row hover-bg" style="font-weight: bold; font-style: italic;"><td>Tax Paid Till Date:</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                  <tr class="table-row hover-bg"><td class="pl-5">Monthly Tax Deduction - YTD</td>
                  <td style="text-align: right;">

                    <div v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head == 'Monthly tax paid till date'">
                     <template>
                     <!--<headytd :pageurl="pgurl" :employee_id="employee_id" :fiscal_year="fiscal_year" :head="'Monthely Tax Deduct'" :current_headvalue="taxdata['monthly_tax_deduct']" :month="fdata.month" :payslip_id="fdata.id"></headytd>-->
                     {{taxhead.value}}
                     </template>
                  </div>

                  </td>
                  <td>&nbsp;</td>
                  </tr>
                  <tr class="table-row hover-bg"><td class="pl-5">One-off Tax Deduction - YTD</td><td style="text-align: right;">
                  <div v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head == 'One-off tax paid till date'">
                     <template>
                     <!--<headytd :pageurl="pgurl" :employee_id="employee_id" :fiscal_year="fiscal_year" :head="'One-off Tax Deduct'" :current_headvalue="taxdata['one_of_tax_deduct']" :month="fdata.month" :payslip_id="fdata.id"></headytd>-->
                     {{taxhead.value}}
                     </template>
                  </div>
                  </td><td>&nbsp;</td></tr>

                  <tr class="table-row hover-bg"><td class="pl-5">AIT Adjustment - YTD</td><td style="text-align: right;">

                  <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Decleared AIT'">
                  {{salaryhead.value}}
                  </span>

                  </td><td>&nbsp;</td></tr>

                  <!-- updates for early return filling -->
                  <tr class="table-row hover-bg"><td class="pl-5">Tax Reduction for Early Return Filing (5% or BDT 25,000 whichever is lower)</td><td style="text-align: right;">

                  <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Early Return Filling Incentive'">
                  {{salaryhead.value}}
                  </span>

                  </td><td>&nbsp;</td></tr>
                  <!-- updates for early return filling -->

                  <tr style="font-weight: bold;"><td colspan="2">Total tax paid till date</td><td class="text-right"><span v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head == 'Total tax paid till date'">{{taxhead.value}}</span></td></tr>
                  <tr class="table-row hover-bg">
                  <td>Remaining Tax Liability</td><td>&nbsp;</td>
                  <td style="text-align: right;">
                  <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Remaining Tax Payable'">
                  {{salaryhead.value}}
                  </span>
                  </td>
                  </tr>
                  <tr class="table-row hover-bg"><td>Remaining Months</td><td>&nbsp;</td>
                  <td style="text-align: right;">
                   <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Remaining Months'">
                  {{salaryhead.value}}
                  </span>
                  </td>
                  </tr>
                  <tr style="font-weight: bold; font-style: italic;"><td colspan="3">Tax deduction in {{fdata.month}} {{fdata.year}}</td></tr>
                  <tr class="table-row hover-bg"><td  class="pl-5">One-off Tax Deduction for {{fdata.month}} {{fdata.year}}</td><td style="text-align: right;">{{taxdata['one_of_tax_deduct']}}</td><td>&nbsp;</td></tr>
                  <tr class="table-row hover-bg"><td  class="pl-5">Monthly Tax Deduction for {{fdata.month}} {{fdata.year}}</td><td style="text-align: right;">{{taxdata['monthly_tax_deduct']}}</td><td>&nbsp;</td></tr>
                  <!--<tr><td>AIT Adjustment for {{fdata.month}} {{fdata.year}}</td><td>&nbsp;</td><td><span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'AIT Adjustment'">
                  {{salaryhead.value}}
                  </span></td></tr>-->
                  <tr class="table-row hover-bg" style="font-weight: bold;"><td>Total Tax Deduction for {{fdata.month}} {{fdata.year}}</td><td>&nbsp;</td><td style="text-align: right;">{{taxdata['total_tax_deduct']}}</td></tr>
           </tbody>
          </table>
       </div>
      </div>
      <div class="row payslip-details-card">
          <div class="col-md-12">
          <h6 class="font-weight-bold">Notes</h6>
          <ul class="list-unstyled p-0 m-0">
            <!-- Afrin: changed 7-9 start -->
            <li>- If an individual enjoys <span style="font-weight: bold;">Rent Free Accommodation</span> from employer, actual rent paid by employer is added to total income and taxed.</li>
            <li>- If an individual enjoys <span style="font-weight: bold;">Conveyance for personal or private use</span> from employer, monthly <template v-if="decimal_setting == 'no'">15,000</template><template v-else>15,000.00</template> for each vehicle upto 1500cc or monthly <template v-if="decimal_setting == 'no'">20,000</template><template v-else>20,000.00</template> for each vehicle from 1501cc to 2000cc or monthly <template v-if="decimal_setting == 'no'">30,000</template><template v-else>30,000.00</template> for each vehicle from 2001cc to 2500cc or monthly <template v-if="decimal_setting == 'no'">50,000</template><template v-else>50,000.00</template> for each vehicle above 2500cc is added to total income and taxed.</li>
            <li>- <span style="font-weight: bold;">Tax is allocated as per the following logic: </span><template v-if="tax_allocation_method == 1"> Spread Tax Equally over the Fiscal Year </template> <template v-else>Spread Tax as per Monthly Income (PAYE)</template></li>
            <!-- Afrin: changed 7-9 end -->
          </ul>
          </div>
       </div>
       </form>
       <iframe id="pdf-frame" style="display: none;"></iframe>
    <!-- barsha -->
  </div>
</template>
<style scoped>
.s-thead{background: #c9c9c9;}
.s-tfoot{background: #e5e5e5;}
</style>

<script>

  export default {
      mounted() {
         // console.log('Payslip started..');
         // console.log(this.componentdata);
      },
      props: [ 'taxcard','company','cardname','emp_etin','emp_department','emp_jobposition','emp_code','emp_joining','emp_branch','emp_gender','emp_birth_date','emp_residency','pmonth','pyear','dynamic_fields'],


      data() {

          return {
              employees : [],
              salaryheads : [],
              taxinfo : [],
              taxdata : [],
              fiscalyears: [],
              adhocfields: [],
              adhocheadsnvalues: [],
              slabs_and_values : [],
              fdata: [],

              company_name:this.company,
              card_title: this.cardname,
              download_file_name: '',
              success: '',
              employee_id: '',
              fiscal_year: '',
              from_date: '',
              to_date: '',
              pay_slip_ref: '',
              pay_slip_name: '',
              month: '',
              year: '',
              adhoc_field: '',
              adhoc_field_value: '',
              exemption_total: '',
              exmp_from_projection: '',
              max_inv_rebate_new: '',
              max_inv_limit_new: '',
              investment_rebate_new: '',
              invested_amount_new: '',
              eligible_investment_rebate_new: '',
              action_loader: false,

              lower_of_amount: 0,

              payslipids: [],

              decimal_setting: 'yes',

              payslip_loader_text: 'We are preparing the data for this employee.',
              payslip_loader : false,
              max_exemption_val : 0,
              tax_allocation_method : 1,

              //CHANGE: max_allowed_rebate_limit
              rebet_slab_global_rate: 0.15,
              max_allowed_rebate_limit: 1000000,
              //CHANGE: max_allowed_rebate_limit


          }
      },

      methods:{
          convertToInt: function(number)
          {
            if(number){
                number = parseInt(number);
            }
            return number;
          },
          setSearch: function(pageflg)
          {
            this.getSalaryinfo();
          },
          getFiscalyears: function()
          {

                      axios.get(this.$api_url+'/getfiscalyears' , {
                          params: {
                              page: 1,
                              per_page: 10,
                              search_query: this.search,
                              search_query_by_id: '',
                          }
                  }).then(function(response){
                  this.fiscalyears = response.data;


              }.bind(this));
          },

          setTaxData: function(tax_info){

            for (var t_id in tax_info) {
            //console.log(tax_info[t_id]['head']);
            //this.child_component_values[f_key][f_id].is_checked = response.data.data[f_key][f_id].is_checked;
            if(tax_info[t_id]['head'] =='Tax Payable')
            this.taxdata['tax_total'] = tax_info[t_id]['value'];

            if(tax_info[t_id]['head'] =='Monthely Tax Deduct')
            this.taxdata['monthly_tax_deduct'] = tax_info[t_id]['value'];

            if(tax_info[t_id]['head'] =='AIT Adjusted Total Tax')   //if(tax_info[t_id]['head'] =='Total Tax Deduct')
            this.taxdata['total_tax_deduct'] = tax_info[t_id]['value'];

            if(tax_info[t_id]['head'] =='One-off Tax Deduct')
            this.taxdata['one_of_tax_deduct'] = tax_info[t_id]['value'];

            if(tax_info[t_id]['head'] =='Off-cycle Tax')
            this.taxdata['off_cycle_tax_deduct'] = tax_info[t_id]['value'];

            }
          },

          getSalaryinfo: function()
          {
      this.payslip_loader = true;
                      axios.get(this.$api_url+'/salary-slip/'+this.employee_id , {
                          params: {
                              fiscal_year: this.fiscal_year,
                              payslip_id: this.fdata.id,
              output_type: 'merge_report',
                              search_query_by_id: '',
                          }
                  }).then(function(response){
                  this.salaryheads = response.data.salary;
                  this.slabs_and_values=response.data.slabsnvalues;
                  this.taxinfo=response.data.tax;
                  let max_inv_limit = 0;
                  let invested_amount = 0;

                  for (let [key, value] of Object.entries(this.taxinfo))
                  {
                    if(value.head === 'Invested Amount'){
                        invested_amount = value.value;
                    }
                    if(value.head === 'Max Allow Inv Limit'){
                        max_inv_limit = value.value;
                    }
                  }
                  if(parseFloat(max_inv_limit.replace(/,/g, '')) < parseFloat(invested_amount.replace(/,/g, '')))
                    this.lower_of_amount = max_inv_limit;
                   else
                    this.lower_of_amount = invested_amount;

                  if(parseFloat(this.lower_of_amount.replace(/,/g, '')) > 10000000)
                    this.lower_of_amount = 10000000;


                  this.adhocfields=response.data.adhocfields;
                  this.adhocheadsnvalues=response.data.adhocheadsnvalues;
                  this.setTaxData(response.data.tax);
                  this.payslip_loader = false;
              }.bind(this));
          },

    getSalaryDataFromDB: function(is_taxcard)
    {
        this.payslip_loader = true;
          axios.get(this.$api_url+'/salary-slip-db/'+this.employee_id , {
            params: {
              fiscal_year: this.fiscal_year,
                              payslip_id: this.fdata.id,
              output_type: 'merge_report',
              is_taxcard: is_taxcard,
                              search_query_by_id: '',
            }
        }).then(function(response){
          this.max_exemption_val = response.data.max_exemption_val;
          this.salaryheads = response.data.salary;
          let eligible_investment_rebate, eligible_investment_limit;
          this.salaryheads.forEach(element => {
                if(element.displayset == 'total_annual_taxable'){
                    this.exemption_total = element.exemption;
                    let exmp_from_projection = (element.annual/3);
                    if(this.decimal_setting == 'no'){
                        this.exmp_from_projection = parseInt(exmp_from_projection).toLocaleString();
                    }else{
                        this.exmp_from_projection = Math.round(exmp_from_projection).toLocaleString();
                    }
                }
                if(element.displayset == 'tax_allocation_method'){
                  this.tax_allocation_method = element.value;
                }

                //CHANGE: max_allowed_rebate_limit
                if(element.head == 'Rebet Slab Global Rate'){
                  this.rebet_slab_global_rate = element.rawvalue / 100;
                }
                if(element.head == 'Max Allowed Rebate Limit'){
                  this.max_allowed_rebate_limit = element.value;
                }
                //CHANGE: max_allowed_rebate_limit
          });
          this.slabs_and_values=response.data.slabsnvalues;
          this.taxinfo=response.data.tax;
          this.taxinfo.forEach(element => {

                if(element.displayset == 'max_investment_limit'){
                  this.max_inv_limit_new = element.value;
                  let max_inv_limit_new = (element.value).replaceAll(',','');
                  if(this.decimal_setting == 'no'){
                    this.max_inv_rebate_new = parseInt((max_inv_limit_new) * (this.rebet_slab_global_rate)).toLocaleString(); // Change: max_allowed_rebate_limit
                  }else{
                    this.max_inv_rebate_new = Math.round((parseFloat(max_inv_limit_new) * (this.rebet_slab_global_rate))).toLocaleString(); // Change: max_allowed_rebate_limit
                  }
                  eligible_investment_limit = parseInt((this.max_inv_rebate_new).replaceAll(',',''));
                }

                if(element.displayset == 'invested_amount'){
                  this.invested_amount_new = element.value;
                  let invested_amount_new = (element.value).replaceAll(',',''); // Change: max_allowed_rebate_limit
                  if(this.decimal_setting == 'no'){
                    this.investment_rebate_new = parseInt((invested_amount_new.replaceAll(',','')) * (this.rebet_slab_global_rate)).toLocaleString(); // Change: max_allowed_rebate_limit
                  }else{
                    this.investment_rebate_new = Math.round((parseFloat(invested_amount_new.replaceAll(',','')) * (this.rebet_slab_global_rate))).toLocaleString(); // Change: max_allowed_rebate_limit
                  }
                  eligible_investment_rebate = parseInt((this.investment_rebate_new).replaceAll(',',''));
                }

                if(eligible_investment_rebate < eligible_investment_limit){
                    if(this.decimal_setting == 'no'){
                        this.eligible_investment_rebate_new = parseInt(eligible_investment_rebate).toLocaleString();
                    }else{
                        this.eligible_investment_rebate_new = Math.round(eligible_investment_rebate).toLocaleString();
                    }
                }else{
                    if(this.decimal_setting == 'no'){
                        this.eligible_investment_rebate_new = parseInt(eligible_investment_limit).toLocaleString();
                    }else{
                        this.eligible_investment_rebate_new = Math.round(eligible_investment_limit).toLocaleString();
                    }
                }

                // CHANGE: max_allowed_rebate_limit - cap eligible_investment_rebate_new to max_allowed_rebate_limit
                let eligible_investment_rebate_raw = parseFloat((this.eligible_investment_rebate_new + '').replaceAll(/,/g, ''));
                let max_allowed_rebate_limit_raw = parseFloat((this.max_allowed_rebate_limit + '').replaceAll(/,/g, ''));
                if(!isNaN(max_allowed_rebate_limit_raw) && max_allowed_rebate_limit_raw > 0 && eligible_investment_rebate_raw > max_allowed_rebate_limit_raw){
                    if(this.decimal_setting == 'no'){
                        this.eligible_investment_rebate_new = parseInt(max_allowed_rebate_limit_raw).toLocaleString();
                    }else{
                        this.eligible_investment_rebate_new = Math.round(max_allowed_rebate_limit_raw).toLocaleString();
                    }
                }
                // END CHANGE: max_allowed_rebate_limit
          });
          let max_inv_limit = 0;
          let invested_amount = 0;

          for (let [key, value] of Object.entries(this.taxinfo))
          {
            if(value.head === 'Invested Amount'){
                invested_amount = value.value;
            }
            if(value.head === 'Max Allow Inv Limit'){
                max_inv_limit = value.value;
            }
          }
          if(parseFloat(max_inv_limit.replace(/,/g, '')) < parseFloat(invested_amount.replace(/,/g, '')))
            this.lower_of_amount = max_inv_limit;
          else
            this.lower_of_amount = invested_amount;

          if(parseFloat(this.lower_of_amount.replace(/,/g, '')) > 10000000)
            this.lower_of_amount = 10000000;

          this.setTaxData(response.data.tax);

          if( is_taxcard != 'update'){
              this.payslip_loader = false;
          }



        }.bind(this));
    },
         getPayslipInfo: function()
         {

               axios.get(this.$api_url+'/payslipinfo/'+this.taxcard, {
                        params: {
                        }
                }).then(function(response){
                this.fdata = response.data.data;
                this.employee_id = this.fdata.employee_id;
                if(this.fdata.id!='')
                  {
                   this.fiscal_year=this.fdata.fiscal_year;
                   this.employee_id=this.fdata.employee_id;
                   this.from_date=this.fdata.from_date;
                   this.to_date=this.fdata.to_date;
                   this.pay_slip_ref=this.fdata.pay_slip_ref;

                   //this.setSearch();
               this.getSalaryDataFromDB('yes');
                   this.pay_slip_name=this.fdata.pay_slip_name;

                  }
            }.bind(this));
         },


        download_file(fileURL, fileName) {
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
            save.download = fileName || filename;
               if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                }else{
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
        }
        else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
       },

       downloadTaxCards: function(tx_card,f_year,email_file=false,prnt_file=false)
          {
                 this.action_loader = true;
                 var send_file = email_file ? 1: 0;
                 axios.get(this.$api_url+'/taxcardpdf/'+f_year+'/'+tx_card , {
                          params: {
                             em_file:  send_file
                          },
                          headers: { 'Content-Type': 'application/json; charset=utf-8', },
                          responseType: 'blob',
                  }).then(function(response){

                  this.action_loader = false;


                  if(response.data){

                  if(response.data.download_name)
                  this.download_file_name = response.data.download_name;
                  else
                  this.download_file_name = this.card_title;

                  if(prnt_file){
                    // this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                    if(response.data.type =='application/json'){
                                let file = new Blob([response.data], {type: 'application/json'});
                                const cast = Promise.resolve(file.text());
                                cast.then((value) => {
                                    let err_obj = JSON.parse(`${value}`);
                                    this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                });
                            }else{
                                this.global_download_file_content(response);
                            }
                  }
                  else if(email_file){
                    if(response.data.success)
                    this.$bvToast.toast(response.data.success, {
                                       title: 'Success',
                                        variant: 'success',
                                        solid: true
                                    });
                    else if(response.data.error)
                    this.$bvToast.toast(response.data.error, {
                                       title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                  }
                  else{
                    // this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                    if(response.data.type =='application/json'){
                                  let file = new Blob([response.data], {type: 'application/json'});
                                  const cast = Promise.resolve(file.text());
                                  cast.then((value) => {
                                      let err_obj = JSON.parse(`${value}`);
                                      this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                  });
                              }else{
                                  this.global_download_file_content(response);
                              }
                    }
                  }
                  else if(response.data.error){
                    this.$bvToast.toast(response.data.error, {
                                       title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                  }else{
                    this.$bvToast.toast('Unexpected server error!', {
                                       title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                  }
                  //console.log(response.data.file_name);
              }.bind(this));
         },
         formSubmit(e) {
              e.preventDefault();
              this.getSalaryDataFromDB('no');
              /* let currentObj = this;
              const config = {
                  headers: { 'content-type': 'multipart/form-data' }
               }
               let formData = new FormData();
               formData.append('employee_id', this.employee_id);
               formData.append('pay_slip_ref', this.pay_slip_ref);
               formData.append('pay_slip_name', this.pay_slip_name);
               formData.append('month', this.month);
               formData.append('year', this.year);
               formData.append('from_date', this.from_date);
               formData.append('to_date', this.to_date);
               formData.append('fiscal_year', this.fiscal_year);
               if(this.adhoc_field!='')
               formData.append('adhoc_field', this.adhoc_field);
               if(this.adhoc_field_value!='')
               formData.append('adhoc_field_value', this.adhoc_field_value);
               axios.post(this.$api_url+'/payslip-action-vue', formData, config)
               .then(function (response) {
                  //currentObj.getSalaryinfo();
                  currentObj.getSalaryDataFromDB('yes');
                  currentObj.success = response.data.success;
                  currentObj.fdata.id = response.data.payslip_id;
                  currentObj.adhoc_field_value="";
                  currentObj.adhoc_field="";
                  currentObj.hideAdhoc();
              })
              .catch(function (error) {
                  currentObj.output = error;
              }); */
          },

          emailTaxCards: function(taxcard)
          {
              this.action_loader = true;
              const config = {
                  headers: { 'content-type': 'multipart/form-data' }
              }
              let formData = new FormData();
              formData.append('payslipids', taxcard);
              formData.append('modification_flag', '4');

              axios.post(this.$api_url+'/modifypayslips', formData, config)

              .then(function (response) {
                this.action_loader = false;

                if(response.data.success)
                    this.$bvToast.toast(response.data.success, {
                                       title: 'Success',
                                        variant: 'success',
                                        solid: true
                                    });



              }.bind(this));
          },

          get_decimal_settings: function()
          {
              axios.get(this.$api_url+'/decimal-settings')

              .then(function (response) {
                this.decimal_setting = response.data;
              }.bind(this));
          }
      },
      created: function(){
         this.getPayslipInfo();
         this.getFiscalyears();
         this.get_decimal_settings();
      }
  }
</script>
